<template>
	<div class="MainBox" @click.stop="SelectActive(-1,$self)">
    <div class="TableHead">
      <ul class="TableHeadLeft">
        <li class="TableHeadLeftRow btnStyleTwo blueBackColor btnRadius" @click="HandleModel(true,1)"><span class="icon iconfont iconicon-test20"></span>{{$t('b.Dealer.CodesShipping')}}</li>
      </ul>
      <ul class="clear"></ul>
    </div>
    <div class="TableHint"><i>*</i> {{$t('c.Common.FileHint')}}</div>

    <div class="TableMain">
      <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!datas"></K-Transition>
      <table class="table StripeTable" v-else>
        <thead>
          <tr>
            <th v-text="$t('c.Common.Numbering')"></th>
            <th>发货方式</th>
            <th v-text="$t('c.Common.Batch')"></th>
            <th v-text="$t('c.Common.Product')"></th>
            <th v-text="$t('c.Common.CodeNumber')"></th>
            <th v-text="$t('c.Common.SuccessfullyQuantity')"></th>
            <th v-text="$t('b.Dealer.ReceivingDealer')"></th>
            <th v-text="$t('c.Common.State')"></th>
            <th v-text="$t('c.Common.CreationTime')"></th>
            <th v-text="$t('c.Common.Operation')"></th>
          </tr>
        </thead>
        <tbody class="TRHoverStyle">
          <tr v-for="(item,index) in datas" v-bind:key="index">
            <td v-text="item.id"></td>
            <td>
              <a v-if="item.shipping_type == 1">采集</a>
              <a v-else-if="item.shipping_type == 2">首尾码</a>
              <a v-else>文件</a>
            </td>
            <td>
              <a v-if="item.batch_info" v-text="item.batch_info.name"></a>
              <a v-else>无</a>
            </td>
            <td>
              <a v-if="item.product" v-text="item.product.name"></a>
              <a v-else>-</a>
            </td>
            <td v-text="item.code_count"></td>
            <td v-text="item.shipping_code_count"></td>
            <td v-text="item.name"></td>
            <td class="TdStatus">
              <a v-if="item.result == 100"><i class="wait"></i>{{$t('c.Common.InProgress')}}</a>
              <a v-else-if="item.result == 200"><i class="reject"></i>{{$t('c.Common.Failure')}}</a>
              <a v-else-if="item.result == 300"><i class="pass"></i>{{$t('c.Common.Completed')}}</a>
              <a v-else-if="item.result == 400"><i class="reject"></i>{{$t('c.Common.Expired')}}</a>
            </td>
            <td v-text="item.created_at"></td>
            <td>
              <div class="btnArray">
                <a class="btnStyleTwo btnRadius blueBackColor" v-if="item.result == 300 && item.filename" @click="DownCodeFile(4, item.id)" v-text="$t('c.Common.Download')"></a>
                <a class="btnStyleTwo btnRadius ProhibitBtn" v-else v-text="$t('c.Common.Download')"></a>
                <a class="btnStyleTwo btnRadius cyanBackColor" v-text="$t('b.CodeActive.ReplaceData')" @click="HandleModel(true,2,item.id)"></a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- 分页器 -->
      <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage" @SkipPage="SkipPage"></K-Paging>

      <!-- 发货窗口 -->
      <div class="ModalBox" v-if="ModelShow">
        <div class="ModalMain">
          <div class="ModalMainHead">
            {{$t('b.Dealer.CodesShipping')}}
            <span class="icon iconfont iconicon-test29 ModalMainHeadClose feedback" @click="HandleModel(false,1)"></span>
          </div>
          <div class="ModalMainBox">
            <ul class="FormStyleTwo">
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle">{{$t('b.Dealer.ShippingType')}}（{{$t('b.Dealer.HintTwo')}}）</p>
                <p>
                  <div class="SelectStyle" @click.stop="SelectActive(0,$self)">
                    {{$t('b.Dealer.'+SelectArr[0].datas[SelectArr[0].ix]+'')}}
                    <ul class="OptionStyleBox" v-if="SelectArr[0].active">
                      <li class="OptionStyleRow" v-for="(item,index) in SelectArr[0].datas" v-bind:key="index" v-text="$t('b.Dealer.'+item+'')" @click="SelectData(0,index)"></li>
                    </ul>
                    <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
                  </div>
                </p>
              </li>
              <li class="FormStyleTwoRow" v-if="role == 30 || role == 50">
                <p class="FormStyleTwoTitle">{{$t('c.Common.Batch')}}（{{$t('b.CodeActive.HintTwo')}}）</p>
                <p>
                  <div class="SelectStyle" @click.stop="SelectActive(1,$self)" v-if="SelectArr[1].datas.length > 0">
                    {{SelectArr[1].datas[SelectArr[1].ix].name}}
                    <ul class="OptionStyleBox" v-if="SelectArr[1].active">
                      <li class='OptionStyleQuery' v-if="SelectArr[1].totalPages > 1" @click.stop><input placeholder="可在此查询内容" v-model="SQueryName" /><a class="OptionStyleQueryBtn" @click.stop="SelectArrQuery(1)">查询</a></li>
                      <ul class="OptionStyleMain">
                        <li class="OptionStyleRow" :class="{OptionStyleRowActive:SelectArr[1].ix == index && !SelectArr[1].isHover}" v-for="(item,index) in SelectArr[1].datas" v-bind:key="index" v-text="item.name" @click="SelectData(1,index)" @mouseover="SelectHover($self,1,true)" @mouseout="SelectHover($self,1,false)"></li>
                        <li class="OptionStyleLoading" @click.stop="SelectArrLoading(1)" v-if="SelectArr[1].totalPages > 1 && SelectArr[1].page < SelectArr[1].totalPages">加载更多</li>
                        <li class="OptionStyleLoading" @click.stop v-if="SelectArr[1].totalPages > 1 && SelectArr[1].page >= SelectArr[1].totalPages">无更多内容</li>
                      </ul>
                    </ul>
                    <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
                  </div>
                  <div v-else class="SelectStyle">无</div>
                </p>
              </li>
              <li class="FormStyleTwoRow" v-if="role == 30">
                <p class="FormStyleTwoTitle">{{$t('c.Common.Product')}}（{{$t('b.Dealer.HintThree')}}）</p>
                <p>
                  <div class="SelectStyle" @click.stop="SelectActive(2,$self)">
                    {{SelectArr[2].datas[SelectArr[2].ix].name}}
                    <ul class="OptionStyleBox" v-if="SelectArr[2].active">
                      <li class='OptionStyleQuery' v-if="SelectArr[2].totalPages > 1" @click.stop><input placeholder="可在此查询内容" v-model="SQueryName" /><a class="OptionStyleQueryBtn" @click.stop="SelectArrQuery(2)">查询</a></li>
                      <ul class="OptionStyleMain">
                        <li class="OptionStyleRow" :class="{OptionStyleRowActive:SelectArr[2].ix == index && !SelectArr[2].isHover}" v-for="(item,index) in SelectArr[2].datas" v-bind:key="index" v-text="item.name" @click="SelectData(2,index)" @mouseover="SelectHover($self,2,true)" @mouseout="SelectHover($self,2,false)"></li>
                        <li class="OptionStyleLoading" @click.stop="SelectArrLoading(2)" v-if="SelectArr[2].totalPages > 1 && SelectArr[2].page < SelectArr[2].totalPages">加载更多</li>
                        <li class="OptionStyleLoading" @click.stop v-if="SelectArr[2].totalPages > 1 && SelectArr[2].page >= SelectArr[2].totalPages">无更多内容</li>
                      </ul>
                    </ul>
                    <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
                  </div>
                </p>
              </li>
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle">{{$t('b.Dealer.ReceivingDealer')}}（{{$t('b.Dealer.HintFour')}}）</p>
                <p>
                  <div class="SelectStyle" @click.stop="SelectActive(3,$self)">
                    {{SelectArr[3].datas[SelectArr[3].ix].name}}
                    <ul class="OptionStyleBox" v-if="SelectArr[3].active">
                      <li class='OptionStyleQuery' v-if="SelectArr[3].totalPages > 1" @click.stop><input placeholder="可在此查询内容" v-model="SQueryName" /><a class="OptionStyleQueryBtn" @click.stop="SelectArrQuery(3)">查询</a></li>
                      <ul class="OptionStyleMain">
                        <li class="OptionStyleRow" :class="{OptionStyleRowActive:SelectArr[3].ix == index && !SelectArr[3].isHover}" v-for="(item,index) in SelectArr[3].datas" v-bind:key="index" v-text="item.name" @click="SelectData(3,index)" @mouseover="SelectHover($self,3,true)" @mouseout="SelectHover($self,3,false)"></li>
                        <li class="OptionStyleLoading" @click.stop="SelectArrLoading(3)" v-if="SelectArr[3].totalPages > 1 && SelectArr[3].page < SelectArr[3].totalPages">加载更多</li>
                        <li class="OptionStyleLoading" @click.stop v-if="SelectArr[3].totalPages > 1 && SelectArr[3].page >= SelectArr[3].totalPages">无更多内容</li>
                      </ul>
                    </ul>
                    <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
                  </div>
                </p>
              </li>
              <li class="FormStyleTwoRow" v-if="SelectArr[0].ix == 0">
                <p class="FormStyleTwoTitle"><i>*</i>{{$t('c.Common.ActiveCode')}}（{{$t('b.CodeActive.HintFour')}}）</p>
                <p><input :placeholder="$t('b.CodeActive.HintFive')" v-model="code" v-on:keyup.13="AddCode" /></p>
              </li>
              <li class="FormStyleTwoRow" v-if="SelectArr[0].ix == 1">
                <p class="FormStyleTwoTitle"><i>*</i>{{$t('c.Common.FirstCode')}}</p>
                <p><input :placeholder="$t('b.CodeActive.HintSix')" v-model="first_code" /></p>
              </li>
              <li class="FormStyleTwoRow" v-if="SelectArr[0].ix == 1">
                <p class="FormStyleTwoTitle"><i>*</i>{{$t('c.Common.LastCode')}}</p>
                <p><input :placeholder="$t('b.CodeActive.HintSeven')" v-model="last_code" /></p>
              </li>
              <li class="FormStyleTwoRow" v-if="SelectArr[0].ix == 2">
                <p class="FormStyleTwoTitle"><i>*</i>{{$t('c.Common.CodeFile')}}（{{$t('c.Common.FileSizeHint')}}）</p>
                <p class="btnArray">
                  <a class="btnStyleTwo btnRadius cyanBackColor"><span class="icon iconfont iconicon-test28"></span>{{$t('c.Common.FileUpload')}}</a>
                  <a class="FormUpFileHint onlyOneRow" v-if="fileTxt" v-text="fileTxt"></a>
                  <input type="file" class="upload" @change="UploadFile" ref="file" />
                </p>
              </li>
            </ul>

            <div class="CodeActiveListBox">
              <ul class="CodeActiveList" v-if="SelectArr[0].ix == 0 && Codes.length > 0">
                <span class="CodeActiveListTitle">当前采集码标<i v-text="Codes.length"></i>个<a class="CodeActiveListRomoveAll feedback NoSelect" @click="Remove('all')">清空</a></span>
                <li v-for="(item,index) in Codes" v-bind:key="index">{{item}}<i class="icon iconfont iconicon-test33 CodeActiveListRomove feedback" @click="Remove(index)"></i></li>
              </ul>
            </div>
          </div>
          <div class="ModalMainFoot">
            <!-- <div class="ModalMainFootLeft feedback"><span class="icon iconfont iconicon-test28"></span>{{$t('c.Common.Document')}}</div> -->
            <div class="ModalMainFootRight btnArray">
              <a class="btnStyleTwo btnRadius grayBackColor" @click="HandleModel(false,1)" v-text="$t('c.Common.Cancel')"></a>
              <a class="btnStyleTwo btnRadius blueBackColor" @click="SubmitForm(1)" v-text="$t('c.Common.Confirm')"></a>
            </div>
          </div>
        </div>
      </div>

      <!-- 数据替换窗口 -->
      <div class="ModalBox" v-if="ModelTwoShow">
        <div class="ModalMain">
          <div class="ModalMainHead">
            {{$t('b.Dealer.CodesShipping')}}
            <span class="icon iconfont iconicon-test29 ModalMainHeadClose feedback" @click="HandleModel(false,2)"></span>
          </div>
          <div class="ModalMainBox">
            <ul class="FormStyleTwo">
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle">{{$t('c.Common.Batch')}}（{{$t('b.CodeActive.HintTwo')}}）</p>
                <p>
                  <div class="SelectStyle" @click.stop="SelectActive(1,$self)" v-if="SelectArr[1].datas.length > 0">
                    {{SelectArr[1].datas[SelectArr[1].ix].name}}
                    <ul class="OptionStyleBox" v-if="SelectArr[1].active">
                      <li class='OptionStyleQuery' v-if="SelectArr[1].totalPages > 1" @click.stop><input placeholder="可在此查询内容" v-model="SQueryName" /><a class="OptionStyleQueryBtn" @click.stop="SelectArrQuery(1)">查询</a></li>
                      <ul class="OptionStyleMain">
                        <li class="OptionStyleRow" :class="{OptionStyleRowActive:SelectArr[1].ix == index && !SelectArr[1].isHover}" v-for="(item,index) in SelectArr[1].datas" v-bind:key="index" v-text="item.name" @click="SelectData(1,index)" @mouseover="SelectHover($self,1,true)" @mouseout="SelectHover($self,1,false)"></li>
                        <li class="OptionStyleLoading" @click.stop="SelectArrLoading(1)" v-if="SelectArr[1].totalPages > 1 && SelectArr[1].page < SelectArr[1].totalPages">加载更多</li>
                        <li class="OptionStyleLoading" @click.stop v-if="SelectArr[1].totalPages > 1 && SelectArr[1].page >= SelectArr[1].totalPages">无更多内容</li>
                      </ul>
                    </ul>
                    <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
                  </div>
                  <div v-else class="SelectStyle">无</div>
                </p>
              </li>
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle">{{$t('c.Common.Product')}}（{{$t('b.Dealer.HintThree')}}）</p>
                <p>
                  <div class="SelectStyle" @click.stop="SelectActive(2,$self)">
                    {{SelectArr[2].datas[SelectArr[2].ix].name}}
                    <ul class="OptionStyleBox" v-if="SelectArr[2].active">
                      <li class='OptionStyleQuery' v-if="SelectArr[2].totalPages > 1" @click.stop><input placeholder="可在此查询内容" v-model="SQueryName" /><a class="OptionStyleQueryBtn" @click.stop="SelectArrQuery(2)">查询</a></li>
                      <ul class="OptionStyleMain">
                        <li class="OptionStyleRow" :class="{OptionStyleRowActive:SelectArr[2].ix == index && !SelectArr[2].isHover}" v-for="(item,index) in SelectArr[2].datas" v-bind:key="index" v-text="item.name" @click="SelectData(2,index)" @mouseover="SelectHover($self,2,true)" @mouseout="SelectHover($self,2,false)"></li>
                        <li class="OptionStyleLoading" @click.stop="SelectArrLoading(2)" v-if="SelectArr[2].totalPages > 1 && SelectArr[2].page < SelectArr[2].totalPages">加载更多</li>
                        <li class="OptionStyleLoading" @click.stop v-if="SelectArr[2].totalPages > 1 && SelectArr[2].page >= SelectArr[2].totalPages">无更多内容</li>
                      </ul>
                    </ul>
                    <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
                  </div>
                </p>
              </li>
              <li class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle">{{$t('b.Dealer.ReceivingDealer')}}（{{$t('b.Dealer.HintFour')}}）</p>
                <p>
                  <div class="SelectStyle" @click.stop="SelectActive(3,$self)">
                    {{SelectArr[3].datas[SelectArr[3].ix].name}}
                    <ul class="OptionStyleBox" v-if="SelectArr[3].active">
                      <li class='OptionStyleQuery' v-if="SelectArr[3].totalPages > 1" @click.stop><input placeholder="可在此查询内容" v-model="SQueryName" /><a class="OptionStyleQueryBtn" @click.stop="SelectArrQuery(3)">查询</a></li>
                      <ul class="OptionStyleMain">
                        <li class="OptionStyleRow" :class="{OptionStyleRowActive:SelectArr[3].ix == index && !SelectArr[3].isHover}" v-for="(item,index) in SelectArr[3].datas" v-bind:key="index" v-text="item.name" @click="SelectData(3,index)" @mouseover="SelectHover($self,3,true)" @mouseout="SelectHover($self,3,false)"></li>
                        <li class="OptionStyleLoading" @click.stop="SelectArrLoading(3)" v-if="SelectArr[3].totalPages > 1 && SelectArr[3].page < SelectArr[3].totalPages">加载更多</li>
                        <li class="OptionStyleLoading" @click.stop v-if="SelectArr[3].totalPages > 1 && SelectArr[3].page >= SelectArr[3].totalPages">无更多内容</li>
                      </ul>
                    </ul>
                    <a class="icon iconfont iconicon-test22 OptionStyleIcon"></a>
                  </div>
                </p>
              </li>
            </ul>
          </div>
          <div class="ModalMainFoot">
            <!-- <div class="ModalMainFootLeft feedback"><span class="icon iconfont iconicon-test28"></span>{{$t('c.Common.Document')}}</div> -->
            <div class="ModalMainFootRight btnArray">
              <a class="btnStyleTwo btnRadius grayBackColor" @click="HandleModel(false,2)" v-text="$t('c.Common.Cancel')"></a>
              <a class="btnStyleTwo btnRadius blueBackColor" @click="SubmitForm(2)" v-text="$t('c.Common.Confirm')"></a>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

	</div>
</template>

<script>
var self;
import axios from 'axios'
import Paging from '@/components/common/Paging.vue'
import Transition from '@/components/common/Transition.vue'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
export default {
  name: 'DealerShipping',
  components: {
    'K-Paging': Paging,
    'K-Transition': Transition,
    'K-Loading': Loading,
    'K-Toast': Toast
  },
  data () {
    return {
      $self:null,
      page:1,
      role:null,
      subHint:'数据加载中...',
      isLoding:true,
      totalPages:0,
      datas:null,
      ModelShow:false,
      ModelTwoShow:false,
      loading:false,
      Toast:{
        state: false,
        type: 0,
        txt: null
      },
      SelectArr:[{
        ix:0,
        active:false,
        datas:["ScanShipping","ExtentShipping","FileShipping"]
      },{
        ix:0,
        page:1,
        totalPages:0,
        active:false,
        isHover:false,
        datas:[]
      },{
        ix:0,
        page:1,
        totalPages:0,
        active:false,
        isHover:false,
        datas:[]
      },{
        ix:0,
        page:1,
        totalPages:0,
        active:false,
        isHover:false,
        datas:[]
      }],
      Codes:[],
      SQueryName:null,
      code:null,
      first_code:null,
      last_code:null,
      fileTxt:null,
      ds_id:null
    }
  },
  created () {
    self = this;
    this.$self = this;
    self.role = localStorage.getItem("wwmxt_Role");
    axios.defaults.headers.common['token'] = localStorage.getItem("wwmxt_Token");
  },
  mounted () {
    self.GetList();
    self.GetProductList();
    self.GetBatchList();
    self.GetDealerList();
  },
  methods: {
    ToastFun (type,txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    ChangeToast () {
      self.Toast.state = false;
    },
    ChangePage (data) {  //上下翻页
      if(data.te == 1){
        if(self.page > 1){
          self.page--
        }
      }else{
        if(self.page < self.totalPages){
          self.page++
        }
      }
      self.GetList();
    },
    SkipPage (data) {  //跳转分页
      self.page = data.ix;
      self.GetList();
    },
    HandleModel (status,te,id) {  //隐藏显示生码模态框
      if(self.SelectArr[2].datas.length > 0 && self.SelectArr[3].datas.length > 0){
        if(te == 1){
          self.ModelShow = status;
        }else{
          self.ds_id = id;
          self.ModelTwoShow = status;
        }
      }else{
        self.ToastFun(1,"产品和经销商内容不能为空！");
      }
    },
    SelectData (ix,six) {  //选中选择框内容
      self.SelectArr[ix].ix = six;
    },
    Remove (ix) {
      if(ix == "all"){
        self.Codes = [];
      }else{
        self.Codes.splice(ix,1);
      }
    },
    GetList () {
      self.datas = null;
      self.isLoding = true;
      axios.get(self.GetServerUrl(1)+"ds/0/"+self.page)
      .then(function (response){
        self.datas = response.data.meta.data;
        self.isLoding = false;

        //总页数
        self.totalPages = response.data.meta.last_page;
      }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    },
    GetBatchList (te) {
      self.datas = null;
      self.isLoding = true;
      axios.get(self.GetServerUrl(1)+"batch_list/"+self.SelectArr[1].page)
      .then(function (response){
        if(!te){
          self.SelectArr[1].datas = response.data.meta.data;
          self.SelectArr[1].totalPages = response.data.meta.last_page;
        }else{
          self.loading = false;
          let datas = response.data.meta.data;
          for(let item in datas){
            self.SelectArr[1].datas.push(datas[item]);
          }
        }
      }).catch(function (error){
        if(!te){
          self.loading = false;
        }
      })
    },
    GetProductList (te) {
      axios.get(self.GetServerUrl(1)+"production_list/"+self.SelectArr[2].page)
      .then(function (response){
        if(!te){
          self.SelectArr[2].datas = response.data.meta.data;
          self.SelectArr[2].totalPages = response.data.meta.last_page;
        }else{
          self.loading = false;
          let datas = response.data.meta.data;
          for(let item in datas){
            self.SelectArr[2].datas.push(datas[item]);
          }
        }
      }).catch(function (error){
        if(!te){
          self.loading = false;
        }
        console.log("产品信息获取失败！");
      })
    },
    GetDealerList (te) {
      axios.get(self.GetServerUrl(1)+"dealer_list/"+self.SelectArr[3].page)
      .then(function (response){
        if(!te){
          self.SelectArr[3].datas = response.data.meta.data;
          self.SelectArr[3].totalPages = response.data.meta.last_page;
        }else{
          self.loading = false;
          let datas = response.data.meta.data;
          for(let item in datas){
            self.SelectArr[3].datas.push(datas[item]);
          }
        }
      }).catch(function (error){
        if(!te){
          self.loading = false;
        }
        console.log("经销商信息获取失败！");
      })
    },
    SubmitForm (te) {  //提交表单
      let ix,Datas,BatchID,ProductID,FormRootID,RootID;
      if(te == 1){
        ix = self.SelectArr[0].ix;
      }else{
        ix = 3;  //数据替换
      }

      //批次不为空时
      if(self.SelectArr[1].datas.length > 0){
        BatchID = self.SelectArr[1].datas[self.SelectArr[1].ix].batch_id;
      }else{
        BatchID = 0;
      }

      RootID = localStorage.getItem("wwmxt_Rootid");
      ProductID = self.SelectArr[2].datas[self.SelectArr[2].ix].production_id
      FormRootID = self.GoDealerID(self.SelectArr[3].datas[self.SelectArr[3].ix].rootid,self.SelectArr[3].datas[self.SelectArr[3].ix].rootid_extid1,self.SelectArr[3].datas[self.SelectArr[3].ix].rootid_extid2,self.SelectArr[3].datas[self.SelectArr[3].ix].rootid_extid3)

      if(ix == 0){
        Datas = {code:self.Codes,form_rootid:FormRootID,shipping_rootid:RootID,batch:BatchID};
        if(self.Codes.length < 1){
          self.ToastFun(1,"码标不能为空！");
          return;
        }
      }else if(ix == 1){
        let first_code = self.FiltrationCode(self.first_code);
        let last_code = self.FiltrationCode(self.last_code);
        if (!first_code) {
          self.ToastFun(1, "首码格式不正确！");
          return;
        }
        if (!last_code) {
          self.ToastFun(1, "尾码格式不正确！");
          return;
        }
        
        Datas = {first_code:first_code,last_code:last_code,form_rootid:FormRootID,shipping_rootid:RootID,batch:BatchID};
      }else if(ix == 2){
        if(!self.fileTxt){
          self.ToastFun(1,"文件不能为空！");
          return;
        }
        let fileDOM;
        fileDOM = this.$refs.file;

        //FormDatas格式提交
        Datas = new FormData();
        Datas.append("file",fileDOM.files[0]);
        Datas.append("batch",BatchID);
        Datas.append("production_id",ProductID);
        Datas.append("form_rootid",FormRootID);
        Datas.append("shipping_rootid",RootID);
      }else{
        URL = "DsCode/CoverData";
        Datas = {form_rootid:FormRootID,shipping_rootid:RootID,batch:BatchID,ds_id:self.ds_id};
      }

      if(ix === 2){ //文件发货
        Datas.append("ds_type", ix);
      }else{
        Datas.ds_type = ix;
      }

      self.loading = true;
      axios.post(self.GetServerUrl(1)+"ds",Datas)
      .then(function (response){
        self.loading = false;

        if(te == 1){
          self.ModelShow = false;
        }else{
          self.ModelTwoShow = false;
        }

        self.ToastFun(0,response.data.message);
        self.GetList();

        //清空历史数据
        if(ix == 0){
          self.Codes= [];
        }else if(ix == 1){
          self.code = null;
          self.first_code = null;
          self.last_code = null;
        }
      }).catch(function (error){
        self.loading = false;
        self.ToastFun(2,self.ErrorHint(error));  //弹窗提醒
      })
    },
    AddCode () {
      let code = self.FiltrationCode(self.code);
      if(code){
        //重复校验
        if(self.RepeatCheck(self.Codes,code) == 1){
          //跨级校验
          if(self.Codes.length > 0){
            if(code.substring(0,1) != self.Codes[0].substring(0,1)){
              self.ToastFun(1,"请勿跨级激活码标！");
              return;
            }else{
              self.Codes.push(code);
              self.code = null;
            }
          }else{
            self.Codes.push(code);
            self.code = null;
          }
        }else{
          self.ToastFun(1,"不能重复插入码标！");
        }
      }else{
        self.ToastFun(1,"码标不正确！");
      }
    },
    UploadFile () {
      if(this.$refs.file.files[0].type != "text/plain"){
        self.ToastFun(1,"文件格式必须为txt！");
        self.fileTxt = null;
        return;
      }
      let size = (this.$refs.file.files[0].size/(1024 * 1024)).toFixed(2);
      if(size < 0.01){
        size = 0.01;
      }
      if(size > 20){
        self.ToastFun(1,"文件大小不能超过20M，当前大小为："+size+"M！");
        self.fileTxt = null;
        return;
      }
      self.fileTxt = '（'+size+'M）' + this.$refs.file.files[0].name;
    }
  }
}
</script>

<style scoped>
  .iconicon-test38{
    font-size:15px !important;
  }
</style>
